import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from '@react-pdf/renderer';
import { usePDFContext } from './pdf.context';
const footerStyles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: '#B4CCFD',
        borderRadius: 20,
        backgroundColor: '#F3F7FF',
        color: '#052669',
        padding: 25,
        fontFamily: 'Inter',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontSize: 12,
        fontWeight: 500,
        marginRight: 10,
        marginLeft: 10
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    textBig: {
        fontWeight: 600,
        fontSize: 20
    }
});
export const Footer = ({ method, date, total }) => {
    const { Text, View } = usePDFContext();
    return (_jsxs(View, { style: footerStyles.container, children: [_jsxs(View, { style: footerStyles.column, children: [_jsx(Text, { children: "Payment Method" }), _jsx(Text, { style: footerStyles.textBig, children: method })] }), _jsxs(View, { style: footerStyles.column, children: [_jsx(Text, { children: date }), _jsx(Text, { style: footerStyles.textBig, children: total })] })] }));
};
